import type { IInfoProps } from './helpers';

export const InfoIcon = ({ variant = 'dark', ...props }: IInfoProps) => {
	if (variant === 'light')
		return (
			<svg
				width='18'
				height='19'
				viewBox='0 0 18 19'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...props}
			>
				<path
					d='M7.875 8.06738H8.625V11.8174M7.875 11.8174H9.375M9 6.19238C9 6.39938 8.832 6.56738 8.625 6.56738C8.418 6.56738 8.25 6.39938 8.25 6.19238C8.25 5.98538 8.418 5.81738 8.625 5.81738C8.832 5.81738 9 5.98538 9 6.19238ZM8.625 15.5674C4.89675 15.5674 1.875 12.5456 1.875 8.81738C1.875 5.08913 4.89675 2.06738 8.625 2.06738C12.3533 2.06738 15.375 5.08913 15.375 8.81738C15.375 12.5456 12.3533 15.5674 8.625 15.5674Z'
					stroke='white'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</svg>
		);

	if (variant === 'square-dark')
		return (
			<svg
				width='12'
				height='12'
				viewBox='0 0 12 12'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...props}
			>
				<path
					opacity='0.4'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.396 6.00065C11.396 10.0472 10.0467 11.3965 6.00016 11.3965C1.95358 11.3965 0.604329 10.0472 0.604329 6.00065C0.604329 1.95407 1.95358 0.604817 6.00016 0.604817C10.0467 0.604817 11.396 1.95407 11.396 6.00065Z'
					stroke='#022745'
					strokeWidth='1.125'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M6.00008 8.27344V6.00135'
					stroke='#022745'
					strokeWidth='1.125'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M6.00246 3.95833H5.99721'
					stroke='#022745'
					strokeWidth='1.125'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</svg>
		);

	if (variant === 'wallet')
		return (
			<svg
				width='25'
				height='24'
				viewBox='0 0 25 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...props}
			>
				<path
					d='M22.0599 10.74L20.7099 9.15996C20.4599 8.85996 20.2499 8.29996 20.2499 7.89996V6.19996C20.2499 5.13996 19.3799 4.26996 18.3199 4.26996H16.6199C16.2199 4.26996 15.6499 4.05996 15.3499 3.80996L13.7699 2.45996C13.0799 1.86996 11.9499 1.86996 11.2599 2.45996L9.65988 3.80996C9.35988 4.05996 8.79988 4.26996 8.39988 4.26996H6.66988C5.60988 4.26996 4.73988 5.13996 4.73988 6.19996V7.89996C4.73988 8.28996 4.53988 8.84996 4.28988 9.14996L2.93988 10.74C2.35988 11.44 2.35988 12.56 2.93988 13.24L4.28988 14.83C4.53988 15.12 4.73988 15.69 4.73988 16.08V17.79C4.73988 18.85 5.60988 19.72 6.66988 19.72H8.40988C8.79988 19.72 9.36988 19.93 9.66988 20.18L11.2499 21.53C11.9399 22.12 13.0699 22.12 13.7599 21.53L15.3399 20.18C15.6399 19.93 16.1999 19.72 16.5999 19.72H18.2999C19.3599 19.72 20.2299 18.85 20.2299 17.79V16.09C20.2299 15.69 20.4399 15.13 20.6899 14.83L22.0399 13.25C22.6499 12.57 22.6499 11.44 22.0599 10.74ZM11.7499 8.12996C11.7499 7.71996 12.0899 7.37996 12.4999 7.37996C12.9099 7.37996 13.2499 7.71996 13.2499 8.12996V12.96C13.2499 13.37 12.9099 13.71 12.4999 13.71C12.0899 13.71 11.7499 13.37 11.7499 12.96V8.12996ZM12.4999 16.87C11.9499 16.87 11.4999 16.42 11.4999 15.87C11.4999 15.32 11.9399 14.87 12.4999 14.87C13.0499 14.87 13.4999 15.32 13.4999 15.87C13.4999 16.42 13.0599 16.87 12.4999 16.87Z'
					fill='#F7B23B'
				/>
			</svg>
		);

	if (variant === 'mini-wallet')
		return (
			<svg
				width='17'
				height='16'
				viewBox='0 0 17 16'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...props}
			>
				<path
					opacity='0.4'
					d='M7.66643 1.63338C8.13309 1.24005 8.88643 1.24005 9.33976 1.63338L10.3931 2.53338C10.5931 2.70005 10.9731 2.84005 11.2398 2.84005H12.3731C13.0798 2.84005 13.6598 3.42005 13.6598 4.12671V5.26005C13.6598 5.52671 13.7998 5.90005 13.9664 6.10005L14.8664 7.15338C15.2598 7.62005 15.2598 8.37338 14.8664 8.82671L13.9664 9.88005C13.7998 10.08 13.6598 10.4534 13.6598 10.72V11.8534C13.6598 12.56 13.0798 13.14 12.3731 13.14H11.2398C10.9731 13.14 10.5998 13.28 10.3998 13.4467L9.34643 14.3467C8.87976 14.74 8.12643 14.74 7.67309 14.3467L6.61976 13.4467C6.41976 13.28 6.03976 13.14 5.77976 13.14H4.61309C3.90643 13.14 3.32643 12.56 3.32643 11.8534V10.7134C3.32643 10.4534 3.19309 10.0734 3.02643 9.88005L2.12643 8.82005C1.73976 8.36005 1.73976 7.61338 2.12643 7.15338L3.02643 6.09338C3.19309 5.89338 3.32643 5.52005 3.32643 5.26005V4.13338C3.32643 3.42671 3.90643 2.84671 4.61309 2.84671H5.76643C6.03309 2.84671 6.40643 2.70671 6.60643 2.54005L7.66643 1.63338Z'
					fill='#022745'
				/>
				<path
					d='M8.50016 11.2467C8.1335 11.2467 7.8335 10.9467 7.8335 10.58C7.8335 10.2133 8.12683 9.91333 8.50016 9.91333C8.86683 9.91333 9.16683 10.2133 9.16683 10.58C9.16683 10.9467 8.8735 11.2467 8.50016 11.2467Z'
					fill='#022745'
				/>
				<path
					d='M8.5 9.14671C8.22667 9.14671 8 8.92004 8 8.64671V5.42004C8 5.14671 8.22667 4.92004 8.5 4.92004C8.77333 4.92004 9 5.14671 9 5.42004V8.64004C9 8.92004 8.78 9.14671 8.5 9.14671Z'
					fill='#022745'
				/>
			</svg>
		);

	if (variant === 'square')
		return (
			<svg
				width='18'
				height='18'
				viewBox='0 0 18 18'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...props}
			>
				<path
					opacity='0.4'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M16.7085 8.69108C16.7085 14.4719 14.781 16.3994 9.00016 16.3994C3.21933 16.3994 1.29183 14.4719 1.29183 8.69108C1.29183 2.91025 3.21933 0.982747 9.00016 0.982747C14.781 0.982747 16.7085 2.91025 16.7085 8.69108Z'
					stroke='white'
					strokeWidth='1.5'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M9.00033 11.937V8.69118'
					stroke='white'
					strokeWidth='1.5'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M9.00359 5.77474H8.99609'
					stroke='white'
					strokeWidth='1.5'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</svg>
		);

	return (
		<svg
			width='24'
			height='25'
			viewBox='0 0 24 25'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				d='M10.5 11.1924H11.5V16.1924M10.5 16.1924H12.5M12 8.69238C12 8.96838 11.776 9.19238 11.5 9.19238C11.224 9.19238 11 8.96838 11 8.69238C11 8.41638 11.224 8.19238 11.5 8.19238C11.776 8.19238 12 8.41638 12 8.69238ZM11.5 21.1924C6.529 21.1924 2.5 17.1634 2.5 12.1924C2.5 7.22138 6.529 3.19238 11.5 3.19238C16.471 3.19238 20.5 7.22138 20.5 12.1924C20.5 17.1634 16.471 21.1924 11.5 21.1924Z'
				stroke='#022745'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};
